// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mcircle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 22rem;
  height: 22rem;
  border-radius: 50%;
  background-color: #e5e5e5;
}

.mrow {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.mtitle {
  text-transform: uppercase;
  font-size: 2rem;
  font-family: "WMFT-Bold";
}

.arow {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 2rem;
  width: 100%;
}

.aimage {
  width: 22rem;
  height: 22rem;
  border-radius: 50%;
  transition: all 0.5s ease-in-out;
}

.aimage:hover {
  transform: scale(1.1);
}

.left-offset {
  position: relative;
  right: 10rem;
}

.right-offset {
  position: relative;
  left: 10rem;
}

.missionaries-heading-style {
  color: var(--primary-color);
  font-size: 2rem;
  font-family: "WMFD-Bold";
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
}

@media (max-width: 1200px) {
  .missionaries-heading-style {
    font-size: 1.5rem;
  }

  .mcircle p {
    font-size: 1rem;
  }

  .mcircle {
    width: 17rem;
    height: 17rem;
  }

  .mcircle p {
    font-size: 1rem;
  }

  .aimage {
    width: 17rem;
    height: 17rem;
  }

  .left-offset {
    position: relative;
    right: 0;
  }

  .right-offset {
    position: relative;
    left: 0;
  }
  .arow {
    justify-content: space-evenly;
  }
}

@media (max-width: 768px) {
  .missionaries-heading-style {
    font-size: 1.5rem;
  }
  .mtitle {
    font-size: 1rem;
  }
  .mcircle {
    width: 13rem;
    height: 13rem;
  }

  .aimage {
    width: 13rem;
    height: 13rem;
  }

  .left-offset {
    position: relative;
    right: 0;
  }

  .right-offset {
    position: relative;
    left: 0;
  }

  .mrow {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    width: 100%;
  }

  .arow {
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
}

@media (max-width: 425px) {
  .missionaries-heading-style {
    font-size: 1rem;
  }
  .mtitle {
    font-size: 0.75rem;
  }
  .mcircle {
    width: 12rem;
    height: 12rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Missionaries.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,OAAO;EACT;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".mcircle {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  width: 22rem;\r\n  height: 22rem;\r\n  border-radius: 50%;\r\n  background-color: #e5e5e5;\r\n}\r\n\r\n.mrow {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.mtitle {\r\n  text-transform: uppercase;\r\n  font-size: 2rem;\r\n  font-family: \"WMFT-Bold\";\r\n}\r\n\r\n.arow {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-evenly;\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.aimage {\r\n  width: 22rem;\r\n  height: 22rem;\r\n  border-radius: 50%;\r\n  transition: all 0.5s ease-in-out;\r\n}\r\n\r\n.aimage:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.left-offset {\r\n  position: relative;\r\n  right: 10rem;\r\n}\r\n\r\n.right-offset {\r\n  position: relative;\r\n  left: 10rem;\r\n}\r\n\r\n.missionaries-heading-style {\r\n  color: var(--primary-color);\r\n  font-size: 2rem;\r\n  font-family: \"WMFD-Bold\";\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .missionaries-heading-style {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .mcircle p {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .mcircle {\r\n    width: 17rem;\r\n    height: 17rem;\r\n  }\r\n\r\n  .mcircle p {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .aimage {\r\n    width: 17rem;\r\n    height: 17rem;\r\n  }\r\n\r\n  .left-offset {\r\n    position: relative;\r\n    right: 0;\r\n  }\r\n\r\n  .right-offset {\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n  .arow {\r\n    justify-content: space-evenly;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .missionaries-heading-style {\r\n    font-size: 1.5rem;\r\n  }\r\n  .mtitle {\r\n    font-size: 1rem;\r\n  }\r\n  .mcircle {\r\n    width: 13rem;\r\n    height: 13rem;\r\n  }\r\n\r\n  .aimage {\r\n    width: 13rem;\r\n    height: 13rem;\r\n  }\r\n\r\n  .left-offset {\r\n    position: relative;\r\n    right: 0;\r\n  }\r\n\r\n  .right-offset {\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .mrow {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 2rem;\r\n    width: 100%;\r\n  }\r\n\r\n  .arow {\r\n    justify-content: space-evenly;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 2rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 425px) {\r\n  .missionaries-heading-style {\r\n    font-size: 1rem;\r\n  }\r\n  .mtitle {\r\n    font-size: 0.75rem;\r\n  }\r\n  .mcircle {\r\n    width: 12rem;\r\n    height: 12rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
